import { z } from 'zod'

export const OutletClosedSchema = z.object({
  errorResolutionType: z.literal('OUTLET_CLOSED'),
})
